import React from "react";
import { Container } from "@mui/material";
import CustomizedBreadcrumbs from "../../component/breadcrumbs/breadcrumbs";
import DrawerPrincipal from "../../component/drawer/drawer-principal";
import MainKanban from "../../component/kanban/main";

function ListBudget() {
  return (
    <>
      <Container maxWidth="lx">
        <DrawerPrincipal
          title={"Orçamento"}
          divOpen={
            <div>
              <div>
                <div className="row mb-3">
                  <CustomizedBreadcrumbs
                    title1={"Home"}
                    link1={"/"}
                    title2={"Lista de Orçamento"}
                    link2={"#"}
                  />
                </div>

                <div style={{ width: "100%", padding: 1 }}>
                  <MainKanban />
                </div>
              </div>
            </div>
          }
        />
      </Container>
    </>
  );
}

export default ListBudget;
